import React, { useEffect } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomPanel,
  DateTime,
  PageHeader,
  Periodo,
  ThreeDots,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { isRouteAllowed } from '../../../../services/permission/menus'
import useMapaCargaAnalitico from './MapaCargaAnaliticaHook'
import OrdemCarregamentoModal from '../MapaCarga/OrdemCarregamentoModal'
import { SplitButton } from 'primereact/splitbutton'
import { useMapaCargaAnaliticaContext } from '../../../../contexts/EntregaContext'

function MapaCargaAnalitico({ history, dispatch, selectedTp }) {
  const { mapaCargaAnaliticaContext, setMapaCargaAnaliticaContext } = useMapaCargaAnaliticaContext()
  const { state, localDispatch } = useMapaCargaAnalitico(mapaCargaAnaliticaContext.selectedPeriodo)

  useEffect(() => {
    localDispatch.fetchVeiculosParaEmissaoMapaCarga(selectedTp, state.periodo.dataInicial, state.periodo.dataFinal)
  }, [selectedTp])

  useEffect(() => {
    setMapaCargaAnaliticaContext(prev => ({
      ...prev,
      selectedPeriodo: state.periodo,
    }))
  }, [state.periodo])

  useEffect(() => {
    if (state.loadingMessage) {
      dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    } else {
      dispatch(hideLoadingBox())
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  const header = (
    <CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange}>
      <div style={{ paddingLeft: '4px', display: 'inline' }}>
        <Btn onClick={() => localDispatch.onBtnExportarExcelClick(state.fleets)}>Exportar</Btn>
      </div>
    </CustomDataTableHeader>
  )

  const splitButtonsItems = [
    {
      label: '2. Agrupado por Grupo de Produtos',
      command: () =>
        localDispatch.onBtnEmitirMapaAgrupadoClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
    {
      label: '3. Consolidado por Produto e Empresa',
      command: () =>
        localDispatch.onBtnEmitirMapaCargaProdutoEmpresaClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
    {
      label: '4. Consolidado Por Grupo e Empresa',
      command: () =>
        localDispatch.onBtnEmitirMapaCargaGrupoEEmpresaClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
    {
      label: '5. Consolidado por Empresa e Cidade',
      command: () =>
        localDispatch.onBtnEmitirMapaCargaEmpresaCidadeClick(
          state.fleets.filter(f => f.selected),
          selectedTp,
        ),
    },
  ]

  // Render
  return (
    <>
      <PageHeader>3.6 - Emitir Mapa de Carga Analítica</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid">
            <div className="p-col-3">
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                Data Prevista da Rota:
              </label>
              <Periodo
                periodoInicial={state.periodo.dataInicial}
                periodoFinal={state.periodo.dataFinal}
                onPesquisar={(pInicial, pFinal) =>
                  localDispatch.onPesquisar(selectedTp, pInicial, pFinal)
                }
              />
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-4">
              <CustomDropdown
                label={'Filtre pela Data Prevista de Entrega'}
                options={state.expectedDates}
                value={state.selectedDataPrevista}
                onChange={localDispatch.onCmbDataPrevistaChange}
              />
            </div>
            <div className="p-col-8" style={{ paddingTop: 33 }}>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '0.5rem',
                  alignItems: 'flex-start',
                }}
              >
                <SplitButton
                  menuStyle={{ width: 250 }}
                  className="bck-primary"
                  label="1. Emitir Mapa de Carga"
                  onClick={() =>
                    localDispatch.onBtnEmitirMapaClick(
                      state.fleets.filter(f => f.selected),
                      selectedTp,
                    )
                  }
                  model={splitButtonsItems}
                />
                <Btn onClick={localDispatch.onBtnLimparFiltroClick}>Limpar Filtro</Btn>
                {isRouteAllowed(48) && (
                  <Btn
                    onClick={() =>
                      localDispatch.onBtnCancelarMapaEmitidoClick(
                        state.fleets.filter(f => f.selected),
                        selectedTp,
                      )
                    }
                  >
                    Cancelar Mapa de Carga
                  </Btn>
                )}
              </div>
            </div>
            <div className="p-col-12">
              <CustomCheckbox
                checked={state.selecionarTodos}
                onChange={() => localDispatch.onChangeSelecionarTodos(!state.selecionarTodos)}
              >
                Selecionar Todos
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <DataTable
                value={state.fleets}
                emptyMessage={'Nenhum veículo disponível para emissão do Mapa de Carga'}
                rows={15}
                paginator={true}
                globalFilter={state.globalFilter}
                header={header}
              >
                <Column
                  header={'#'}
                  body={item => (
                    <CustomCheckbox
                      checked={item.selected}
                      onChange={() => localDispatch.onItemClicked(item)}
                    />
                  )}
                  style={tableCellCentered(60)}
                />
                <Column
                  field={'expected_date'}
                  header={'Data Prevista'}
                  style={tableCellCentered(100)}
                  body={fleet => <DateTime>{fleet.expected_date}</DateTime>}
                />
                <Column field={'vehicle_badge'} header={'Placa'} />
                <Column
                  field={'mapa_emitido'}
                  header={'Mapa de Carga Emitido'}
                  style={tableCellCentered(200)}
                  body={fleet =>
                    fleet.mapa_emitido ? (
                      <div style={{ textAlign: 'center', color: 'green' }}>Sim</div>
                    ) : (
                      <div style={{ textAlign: 'center', color: 'red' }}>Não</div>
                    )
                  }
                />
                <Column
                  field={'qte_deliveries'}
                  header={'Qte Entregas'}
                  style={tableCellCentered(150)}
                />
                <Column field={'qte_sku'} header={'Qte SKUs'} style={tableCellCentered(100)} />
                <Column field={'weight'} header={'Peso'} style={tableCellCentered(100)} />
                <Column
                  header={'Menu'}
                  style={tableCellCentered(80)}
                  body={fleet => (
                    <ThreeDots
                      items={['Ordem Carregamento']}
                      onClick={item => localDispatch.onMenuItemClick(item, fleet)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <OrdemCarregamentoModal
        visible={state.selectedFleet !== null}
        deliveries={
          state.selectedFleet && state.selectedFleet.deliveries
            ? state.selectedFleet.deliveries
            : []
        }
        onResponse={localDispatch.onModalResponse}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MapaCargaAnalitico))
